import React from 'react';

import Container from '../layouts/Container';
import Wrapper from '../layouts/Wrapper';
import ChromeButton from '../layouts/ChromeButton';
import FirefoxButton from '../layouts/FirefoxButton';

const InvalidBrowser = ({ ...props }) => {
  return (
    <Container {...props}>
      <Wrapper>
        <h3>Este navegador não é suportado!</h3>
        <p>
          Para continuar, utilize a versão mais recente de um dos navegadores
          abaixo:
        </p>
        <ChromeButton />
        <FirefoxButton />
      </Wrapper>
    </Container>
  );
};

export default InvalidBrowser;
